module.exports = __webpack_public_path__ + "img/21_mains_twisted.dd0b564f.jpg";